import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { history as historyPropTypes } from 'history-prop-types';
import CustomTable from './table';

const TABLE_CONFIG = {
  columns: [
    {
      caption: 'Nazwa',
      dataField: 'name',
      sort: true,
    },
  ],
  noItemsFoundText: 'Brak elementów',
  initialSort: {
    sortField: 'name',
    sortDirection: 'asc',
  },
  filterFields: 'name',
};

class CommonList extends PureComponent {
  state = {
    data: [],
    totalCount: 0,
    isLoading: true,
  };

  getData = async (params) => {
    const { getItems } = this.props;

    this.setState({
      isLoading: true,
    });

    try {
      const { data, totalCount } = await getItems(params);

      this.setState({
        data,
        totalCount,
        isLoading: false,
      });
    } catch {
      this.setState({
        isLoading: false,
      });
    }
  };

  onRowClick = (ev) => {
    const { history, detailsUrl } = this.props;
    if (!detailsUrl) {
      return;
    }

    const {
      currentTarget: { id },
    } = ev;

    history.push(`${detailsUrl}/${id}`);
  };

  handleRedirect = () => {
    const { newUrl, history } = this.props;

    if (!newUrl) {
      return;
    }

    history.push(newUrl);
  }

  render() {
    const {
      canAdd,
      tableConfig,
    } = this.props;
    const { data, isLoading, totalCount } = this.state;

    return (
      <>
        {canAdd && (
          <button
            type="button"
            className="btn btn-outline-primary position-fixed btn-add"
            onClick={this.handleRedirect}
          >
            Dodaj
          </button>
        )}
        {/* <Breadcrumb>

        </Breadcrumb> */}
        <CustomTable
          config={tableConfig || TABLE_CONFIG}
          items={data}
          fetchData={this.getData}
          totalCount={totalCount}
          isLoading={isLoading}
          onRowClick={this.onRowClick}
          pagination
        />
      </>
    );
  }
}

CommonList.propTypes = {
  getItems: PropTypes.func.isRequired,
  canAdd: PropTypes.bool,
  newUrl: PropTypes.string,
  detailsUrl: PropTypes.string,
  tableConfig: PropTypes.objectOf(PropTypes.shape),
  history: PropTypes.shape(historyPropTypes).isRequired,
};

CommonList.defaultProps = {
  canAdd: false,
  newUrl: '',
  detailsUrl: '',
  tableConfig: null,
};

export default withRouter(CommonList);
